import { connect } from 'react-redux';
import { DistributionYears } from './DistributionYears';
import { goalId as selectedGoalId } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import RouteDictionary from '../../WhatIfsRouteDictionary';
import { applyWhatIf, updateWhatIfsData } from '../../WhatIfsActions';
import {
  areOptionsLoaded,
  loading,
  nullableFpIdSelector,
  nullableGroupTitleSelector,
  nullableTitleSelector,
  whatIfInnerSelector,
  whatIfTemplateInnerSelector,
} from '../../WhatIfsSelector';

const mapStateToProps = (state, ownProps) => ({
  fpId: nullableFpIdSelector(state),
  goalId: selectedGoalId(state),
  areOptionsLoaded: areOptionsLoaded(state),
  whatIf: whatIfInnerSelector(state, ownProps),
  whatIfTemplate: whatIfTemplateInnerSelector(state, ownProps),
  isLoading: loading(state),
  title: nullableTitleSelector(state, ownProps),
  groupTitle: nullableGroupTitleSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  storeData: (goalId, whatIfType) => (data, clientId) => {
    dispatch(updateWhatIfsData(clientId, goalId, whatIfType, data));
  },

  applyWhatIf: (clientId, fpId, goalId, whatIf, whatIfTemplate) => () => {
    dispatch(
      applyWhatIf(
        clientId,
        fpId,
        goalId,
        whatIf,
        RouteDictionary[whatIfTemplate.WhatIfType],
        Object.keys(whatIfTemplate),
        whatIfTemplate.WhatIfType,
      ),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DistributionYears);
